import { useRoutes, Navigate } from 'react-router-dom';
// PC端页面导入
import PCHome from '@/pages/AixueHome/index';
import PCPhonics from '@/pages/AixuePhonics/index';
import PCAi from '@/pages/AixueAi/index';
import PCAbout from '@/pages/AixueAbout/index';
import PCJoin from '@/pages/AixueJoin/index';
import PCNotFound from '@/pages/NotFound';

export default function Router() {
  // PC端路由配置
  const route = [
    { path: '/', element: <PCHome /> },
    { path: '/aixue-phonics', element: <PCPhonics /> },
    { path: '/aixue-ai', element: <PCAi /> },
    { path: '/aixue-about', element: <PCAbout /> },
    { path: '/aixue-join', element: <PCJoin /> },
    {
      path: '/404',
      element: <PCNotFound />,
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ];

  // 根据设备类型选择路由
  const routes = useRoutes(route);

  return routes;
}
